<ng-container *ngIf="isLoggedIn && currentRoutePath !== PAGES.LOGOUT else showLoggedOutView">
  <ng-container *ngIf="userService?.userDetails else showUserDetailProgressLoader">
    <app-main-header *ngIf="showUserDetailProgressLoader" [isMenuCollapsed]="isMenuCollapsed" (menuCollapsedFromHeaderEvent)="isMenuCollapsed = $event"></app-main-header>
    <div class="app-container">
      <app-menu [isMenuCollapsed]="isMenuCollapsed" (menuCollapsedFromDocumentEvent)="isMenuCollapsed = $event"></app-menu>
      <main>
        <router-outlet></router-outlet>
      </main>
    </div>
    <app-toast></app-toast>
  </ng-container>
</ng-container>

<!---------------- START OF LOG-OUT VIEW ---------------->
<ng-template #showLoggedOutView>
  <div class="app-container">
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</ng-template>
<!----------------- END OF LOG-OUT VIEW ------------------>

<!--------- START OF USER-DETAIL PROGRESS LOADER --------->
<ng-template #showUserDetailProgressLoader>
  <div class="user-detail-progress-loader"
       *ngIf="isLoggedIn && !userService?.userDetails">
    <motif-progress-loader [show]="true" [fullScreen]="true"></motif-progress-loader>
  </div>
</ng-template>
<!---------- END OF USER-DETAIL PROGRESS LOADER ---------->
